var cov_9djxi2lkq = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Scroll/Scroll.tsx",
      hash = "42d7581bc2911e0a6e559712f1970be7f90140e1",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Scroll/Scroll.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 25
        },
        end: {
          line: 15,
          column: 27
        }
      },
      "1": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 16
        }
      },
      "2": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 24
        }
      },
      "3": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 24
        }
      },
      "4": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 31
        }
      },
      "5": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 31
        }
      },
      "6": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 19
        }
      },
      "7": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 19
        }
      },
      "8": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 23
        }
      },
      "9": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 24
        }
      },
      "10": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 46
        }
      },
      "11": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "12": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 48
        }
      },
      "13": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 42
        }
      },
      "14": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 54
        }
      },
      "15": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 54
        }
      },
      "16": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 50
        }
      },
      "17": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 48
        }
      },
      "18": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 60
        }
      },
      "19": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 58
        }
      },
      "20": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 54
        }
      },
      "21": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 62
        }
      },
      "22": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 29
        }
      },
      "23": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 28
        }
      },
      "24": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 85
        }
      },
      "25": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 94
        }
      },
      "26": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 93
        }
      },
      "27": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 65
        }
      },
      "28": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 72
        }
      },
      "29": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 65
        }
      },
      "30": {
        start: {
          line: 91,
          column: 50
        },
        end: {
          line: 91,
          column: 60
        }
      },
      "31": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 93,
          column: 78
        }
      },
      "32": {
        start: {
          line: 92,
          column: 47
        },
        end: {
          line: 92,
          column: 61
        }
      },
      "33": {
        start: {
          line: 93,
          column: 9
        },
        end: {
          line: 93,
          column: 78
        }
      },
      "34": {
        start: {
          line: 93,
          column: 64
        },
        end: {
          line: 93,
          column: 78
        }
      },
      "35": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 32
        }
      },
      "36": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 68
        }
      },
      "37": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 78
        }
      },
      "38": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 76
        }
      },
      "39": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 68
        }
      },
      "40": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 75
        }
      },
      "41": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "42": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 71
        }
      },
      "43": {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 106,
          column: 81
        }
      },
      "44": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 79
        }
      },
      "45": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 62
        }
      },
      "46": {
        start: {
          line: 109,
          column: 35
        },
        end: {
          line: 109,
          column: 62
        }
      },
      "47": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 58
        }
      },
      "48": {
        start: {
          line: 113,
          column: 28
        },
        end: {
          line: 113,
          column: 58
        }
      },
      "49": {
        start: {
          line: 114,
          column: 28
        },
        end: {
          line: 114,
          column: 69
        }
      },
      "50": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 122,
          column: 5
        }
      },
      "51": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 29
        }
      },
      "52": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 118,
          column: 31
        }
      },
      "53": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 29
        }
      },
      "54": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 31
        }
      },
      "55": {
        start: {
          line: 124,
          column: 45
        },
        end: {
          line: 124,
          column: 55
        }
      },
      "56": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 95
        }
      },
      "57": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 99
        }
      },
      "58": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 28
        }
      },
      "59": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 54
        }
      },
      "60": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 22
        }
      },
      "61": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 36
        }
      },
      "62": {
        start: {
          line: 136,
          column: 30
        },
        end: {
          line: 136,
          column: 36
        }
      },
      "63": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 28
        }
      },
      "64": {
        start: {
          line: 139,
          column: 18
        },
        end: {
          line: 139,
          column: 36
        }
      },
      "65": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 143,
          column: 5
        }
      },
      "66": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 142,
          column: 53
        }
      },
      "67": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 39
        }
      },
      "68": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 39
        }
      },
      "69": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 19
        }
      },
      "70": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 158,
          column: 5
        }
      },
      "71": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 70
        }
      },
      "72": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 26
        }
      },
      "73": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 170,
          column: 5
        }
      },
      "74": {
        start: {
          line: 167,
          column: 6
        },
        end: {
          line: 167,
          column: 71
        }
      },
      "75": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 81
        }
      },
      "76": {
        start: {
          line: 169,
          column: 6
        },
        end: {
          line: 169,
          column: 79
        }
      },
      "77": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 175,
          column: 5
        }
      },
      "78": {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 172,
          column: 72
        }
      },
      "79": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 81
        }
      },
      "80": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 174,
          column: 80
        }
      },
      "81": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 27
        }
      },
      "82": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 195,
          column: 5
        }
      },
      "83": {
        start: {
          line: 192,
          column: 6
        },
        end: {
          line: 192,
          column: 21
        }
      },
      "84": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 194,
          column: 21
        }
      },
      "85": {
        start: {
          line: 197,
          column: 26
        },
        end: {
          line: 197,
          column: 36
        }
      },
      "86": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 18
        }
      },
      "87": {
        start: {
          line: 202,
          column: 12
        },
        end: {
          line: 202,
          column: 44
        }
      },
      "88": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 203,
          column: 20
        }
      },
      "89": {
        start: {
          line: 203,
          column: 15
        },
        end: {
          line: 203,
          column: 20
        }
      },
      "90": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 20
        }
      },
      "91": {
        start: {
          line: 204,
          column: 15
        },
        end: {
          line: 204,
          column: 20
        }
      },
      "92": {
        start: {
          line: 205,
          column: 12
        },
        end: {
          line: 205,
          column: 44
        }
      },
      "93": {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 206,
          column: 20
        }
      },
      "94": {
        start: {
          line: 206,
          column: 15
        },
        end: {
          line: 206,
          column: 20
        }
      },
      "95": {
        start: {
          line: 207,
          column: 4
        },
        end: {
          line: 207,
          column: 20
        }
      },
      "96": {
        start: {
          line: 207,
          column: 15
        },
        end: {
          line: 207,
          column: 20
        }
      },
      "97": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 211,
          column: 5
        }
      },
      "98": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 55
        }
      },
      "99": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 213,
          column: 19
        }
      },
      "100": {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 214,
          column: 19
        }
      },
      "101": {
        start: {
          line: 218,
          column: 20
        },
        end: {
          line: 218,
          column: 31
        }
      },
      "102": {
        start: {
          line: 219,
          column: 20
        },
        end: {
          line: 219,
          column: 31
        }
      },
      "103": {
        start: {
          line: 220,
          column: 70
        },
        end: {
          line: 220,
          column: 80
        }
      },
      "104": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 221,
          column: 36
        }
      },
      "105": {
        start: {
          line: 221,
          column: 30
        },
        end: {
          line: 221,
          column: 36
        }
      },
      "106": {
        start: {
          line: 222,
          column: 24
        },
        end: {
          line: 222,
          column: 51
        }
      },
      "107": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 226,
          column: 5
        }
      },
      "108": {
        start: {
          line: 223,
          column: 37
        },
        end: {
          line: 223,
          column: 67
        }
      },
      "109": {
        start: {
          line: 224,
          column: 6
        },
        end: {
          line: 224,
          column: 29
        }
      },
      "110": {
        start: {
          line: 225,
          column: 6
        },
        end: {
          line: 225,
          column: 12
        }
      },
      "111": {
        start: {
          line: 228,
          column: 19
        },
        end: {
          line: 228,
          column: 65
        }
      },
      "112": {
        start: {
          line: 229,
          column: 19
        },
        end: {
          line: 229,
          column: 24
        }
      },
      "113": {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 232,
          column: 5
        }
      },
      "114": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 96
        }
      },
      "115": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 57
        }
      },
      "116": {
        start: {
          line: 234,
          column: 51
        },
        end: {
          line: 234,
          column: 57
        }
      },
      "117": {
        start: {
          line: 236,
          column: 18
        },
        end: {
          line: 236,
          column: 39
        }
      },
      "118": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 47
        }
      },
      "119": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 96
        }
      },
      "120": {
        start: {
          line: 238,
          column: 17
        },
        end: {
          line: 238,
          column: 96
        }
      },
      "121": {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 80
        }
      },
      "122": {
        start: {
          line: 239,
          column: 30
        },
        end: {
          line: 239,
          column: 80
        }
      },
      "123": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 243,
          column: 46
        }
      },
      "124": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 28
        }
      },
      "125": {
        start: {
          line: 243,
          column: 11
        },
        end: {
          line: 243,
          column: 46
        }
      },
      "126": {
        start: {
          line: 243,
          column: 24
        },
        end: {
          line: 243,
          column: 46
        }
      },
      "127": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 24
        }
      },
      "128": {
        start: {
          line: 251,
          column: 62
        },
        end: {
          line: 251,
          column: 72
        }
      },
      "129": {
        start: {
          line: 252,
          column: 30
        },
        end: {
          line: 252,
          column: 49
        }
      },
      "130": {
        start: {
          line: 253,
          column: 16
        },
        end: {
          line: 253,
          column: 67
        }
      },
      "131": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 256,
          column: 5
        }
      },
      "132": {
        start: {
          line: 255,
          column: 6
        },
        end: {
          line: 255,
          column: 85
        }
      },
      "133": {
        start: {
          line: 260,
          column: 4
        },
        end: {
          line: 260,
          column: 73
        }
      },
      "134": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 81
        }
      },
      "135": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 268,
          column: 43
        }
      },
      "136": {
        start: {
          line: 272,
          column: 33
        },
        end: {
          line: 272,
          column: 43
        }
      },
      "137": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 273,
          column: 22
        }
      },
      "138": {
        start: {
          line: 274,
          column: 21
        },
        end: {
          line: 274,
          column: 40
        }
      },
      "139": {
        start: {
          line: 275,
          column: 18
        },
        end: {
          line: 275,
          column: 53
        }
      },
      "140": {
        start: {
          line: 276,
          column: 18
        },
        end: {
          line: 276,
          column: 53
        }
      },
      "141": {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 278,
          column: 37
        }
      },
      "142": {
        start: {
          line: 278,
          column: 17
        },
        end: {
          line: 278,
          column: 37
        }
      },
      "143": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 279,
          column: 37
        }
      },
      "144": {
        start: {
          line: 279,
          column: 17
        },
        end: {
          line: 279,
          column: 37
        }
      },
      "145": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 282,
          column: 32
        }
      },
      "146": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 24
        }
      },
      "147": {
        start: {
          line: 289,
          column: 23
        },
        end: {
          line: 289,
          column: 64
        }
      },
      "148": {
        start: {
          line: 295,
          column: 8
        },
        end: {
          line: 295,
          column: 18
        }
      },
      "149": {
        start: {
          line: 296,
          column: 30
        },
        end: {
          line: 296,
          column: 49
        }
      },
      "150": {
        start: {
          line: 297,
          column: 4
        },
        end: {
          line: 307,
          column: 5
        }
      },
      "151": {
        start: {
          line: 298,
          column: 18
        },
        end: {
          line: 298,
          column: 93
        }
      },
      "152": {
        start: {
          line: 299,
          column: 17
        },
        end: {
          line: 299,
          column: 90
        }
      },
      "153": {
        start: {
          line: 300,
          column: 6
        },
        end: {
          line: 300,
          column: 30
        }
      },
      "154": {
        start: {
          line: 301,
          column: 6
        },
        end: {
          line: 301,
          column: 30
        }
      },
      "155": {
        start: {
          line: 302,
          column: 6
        },
        end: {
          line: 302,
          column: 32
        }
      },
      "156": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 303,
          column: 32
        }
      },
      "157": {
        start: {
          line: 304,
          column: 6
        },
        end: {
          line: 304,
          column: 74
        }
      },
      "158": {
        start: {
          line: 305,
          column: 6
        },
        end: {
          line: 305,
          column: 27
        }
      },
      "159": {
        start: {
          line: 306,
          column: 6
        },
        end: {
          line: 306,
          column: 26
        }
      },
      "160": {
        start: {
          line: 320,
          column: 8
        },
        end: {
          line: 320,
          column: 18
        }
      },
      "161": {
        start: {
          line: 321,
          column: 30
        },
        end: {
          line: 321,
          column: 49
        }
      },
      "162": {
        start: {
          line: 322,
          column: 16
        },
        end: {
          line: 322,
          column: 23
        }
      },
      "163": {
        start: {
          line: 324,
          column: 22
        },
        end: {
          line: 327,
          column: 5
        }
      },
      "164": {
        start: {
          line: 329,
          column: 20
        },
        end: {
          line: 329,
          column: 65
        }
      },
      "165": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 73
        }
      },
      "166": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 332,
          column: 70
        }
      },
      "167": {
        start: {
          line: 334,
          column: 4
        },
        end: {
          line: 364,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 34
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 50
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 22
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 79
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 45
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 90
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        },
        loc: {
          start: {
            line: 96,
            column: 25
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 96
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        loc: {
          start: {
            line: 112,
            column: 17
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 112
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 12
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 130
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 135,
            column: 2
          },
          end: {
            line: 135,
            column: 3
          }
        },
        loc: {
          start: {
            line: 135,
            column: 43
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 135
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 64
          },
          end: {
            line: 149,
            column: 3
          }
        },
        line: 146
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 151,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        },
        loc: {
          start: {
            line: 151,
            column: 32
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 151
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 36
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 155
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 161,
            column: 2
          },
          end: {
            line: 161,
            column: 3
          }
        },
        loc: {
          start: {
            line: 161,
            column: 32
          },
          end: {
            line: 163,
            column: 3
          }
        },
        line: 161
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 3
          }
        },
        loc: {
          start: {
            line: 165,
            column: 33
          },
          end: {
            line: 177,
            column: 3
          }
        },
        line: 165
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 179,
            column: 3
          }
        },
        loc: {
          start: {
            line: 179,
            column: 18
          },
          end: {
            line: 215,
            column: 3
          }
        },
        line: 179
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 217,
            column: 2
          },
          end: {
            line: 217,
            column: 3
          }
        },
        loc: {
          start: {
            line: 217,
            column: 33
          },
          end: {
            line: 248,
            column: 3
          }
        },
        line: 217
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 223,
            column: 29
          },
          end: {
            line: 223,
            column: 30
          }
        },
        loc: {
          start: {
            line: 223,
            column: 37
          },
          end: {
            line: 223,
            column: 67
          }
        },
        line: 223
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 250,
            column: 2
          },
          end: {
            line: 250,
            column: 3
          }
        },
        loc: {
          start: {
            line: 250,
            column: 106
          },
          end: {
            line: 257,
            column: 3
          }
        },
        line: 250
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 259,
            column: 2
          },
          end: {
            line: 259,
            column: 3
          }
        },
        loc: {
          start: {
            line: 259,
            column: 30
          },
          end: {
            line: 261,
            column: 3
          }
        },
        line: 259
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 263,
            column: 2
          },
          end: {
            line: 263,
            column: 3
          }
        },
        loc: {
          start: {
            line: 263,
            column: 29
          },
          end: {
            line: 265,
            column: 3
          }
        },
        line: 263
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 267,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        },
        loc: {
          start: {
            line: 267,
            column: 34
          },
          end: {
            line: 269,
            column: 3
          }
        },
        line: 267
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 271,
            column: 2
          },
          end: {
            line: 271,
            column: 3
          }
        },
        loc: {
          start: {
            line: 271,
            column: 33
          },
          end: {
            line: 285,
            column: 3
          }
        },
        line: 271
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 288,
            column: 2
          },
          end: {
            line: 288,
            column: 3
          }
        },
        loc: {
          start: {
            line: 288,
            column: 35
          },
          end: {
            line: 308,
            column: 3
          }
        },
        line: 288
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 310,
            column: 2
          },
          end: {
            line: 310,
            column: 3
          }
        },
        loc: {
          start: {
            line: 310,
            column: 11
          },
          end: {
            line: 365,
            column: 3
          }
        },
        line: 310
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 93,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 93,
            column: 78
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 93,
            column: 78
          }
        }],
        line: 92
      },
      "1": {
        loc: {
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 93,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 93,
            column: 78
          }
        }, {
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 93,
            column: 78
          }
        }],
        line: 93
      },
      "2": {
        loc: {
          start: {
            line: 93,
            column: 13
          },
          end: {
            line: 93,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 13
          },
          end: {
            line: 93,
            column: 19
          }
        }, {
          start: {
            line: 93,
            column: 23
          },
          end: {
            line: 93,
            column: 62
          }
        }],
        line: 93
      },
      "3": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }],
        line: 104
      },
      "4": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 62
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 109,
            column: 62
          }
        }],
        line: 109
      },
      "5": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 58
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 58
          }
        }],
        line: 113
      },
      "6": {
        loc: {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        }],
        line: 116
      },
      "7": {
        loc: {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 19
          }
        }, {
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 116,
            column: 35
          }
        }],
        line: 116
      },
      "8": {
        loc: {
          start: {
            line: 124,
            column: 30
          },
          end: {
            line: 124,
            column: 40
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 124,
            column: 38
          },
          end: {
            line: 124,
            column: 40
          }
        }],
        line: 124
      },
      "9": {
        loc: {
          start: {
            line: 125,
            column: 13
          },
          end: {
            line: 125,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 47
          },
          end: {
            line: 125,
            column: 58
          }
        }, {
          start: {
            line: 125,
            column: 61
          },
          end: {
            line: 125,
            column: 66
          }
        }],
        line: 125
      },
      "10": {
        loc: {
          start: {
            line: 125,
            column: 71
          },
          end: {
            line: 125,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 81
          },
          end: {
            line: 125,
            column: 90
          }
        }, {
          start: {
            line: 125,
            column: 93
          },
          end: {
            line: 125,
            column: 94
          }
        }],
        line: 125
      },
      "11": {
        loc: {
          start: {
            line: 126,
            column: 14
          },
          end: {
            line: 126,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 49
          },
          end: {
            line: 126,
            column: 61
          }
        }, {
          start: {
            line: 126,
            column: 64
          },
          end: {
            line: 126,
            column: 70
          }
        }],
        line: 126
      },
      "12": {
        loc: {
          start: {
            line: 126,
            column: 75
          },
          end: {
            line: 126,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 85
          },
          end: {
            line: 126,
            column: 94
          }
        }, {
          start: {
            line: 126,
            column: 97
          },
          end: {
            line: 126,
            column: 98
          }
        }],
        line: 126
      },
      "13": {
        loc: {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 136,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 136,
            column: 36
          }
        }, {
          start: {
            line: 136,
            column: 4
          },
          end: {
            line: 136,
            column: 36
          }
        }],
        line: 136
      },
      "14": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        }],
        line: 141
      },
      "15": {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }],
        line: 156
      },
      "16": {
        loc: {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 156,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 156,
            column: 10
          }
        }, {
          start: {
            line: 156,
            column: 14
          },
          end: {
            line: 156,
            column: 30
          }
        }],
        line: 156
      },
      "17": {
        loc: {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 170,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 170,
            column: 5
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 170,
            column: 5
          }
        }],
        line: 166
      },
      "18": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 175,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 175,
            column: 5
          }
        }, {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 175,
            column: 5
          }
        }],
        line: 171
      },
      "19": {
        loc: {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        }, {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        }],
        line: 191
      },
      "20": {
        loc: {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 199,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 199,
            column: 20
          },
          end: {
            line: 199,
            column: 51
          }
        }],
        line: 199
      },
      "21": {
        loc: {
          start: {
            line: 200,
            column: 6
          },
          end: {
            line: 200,
            column: 53
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 200,
            column: 21
          },
          end: {
            line: 200,
            column: 53
          }
        }],
        line: 200
      },
      "22": {
        loc: {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 20
          }
        }, {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 20
          }
        }],
        line: 203
      },
      "23": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 20
          }
        }, {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 20
          }
        }],
        line: 204
      },
      "24": {
        loc: {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 206,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 206,
            column: 20
          }
        }, {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 206,
            column: 20
          }
        }],
        line: 206
      },
      "25": {
        loc: {
          start: {
            line: 207,
            column: 4
          },
          end: {
            line: 207,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 207,
            column: 4
          },
          end: {
            line: 207,
            column: 20
          }
        }, {
          start: {
            line: 207,
            column: 4
          },
          end: {
            line: 207,
            column: 20
          }
        }],
        line: 207
      },
      "26": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        }],
        line: 209
      },
      "27": {
        loc: {
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 209,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 209,
            column: 18
          }
        }, {
          start: {
            line: 209,
            column: 22
          },
          end: {
            line: 209,
            column: 31
          }
        }],
        line: 209
      },
      "28": {
        loc: {
          start: {
            line: 220,
            column: 12
          },
          end: {
            line: 220,
            column: 65
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 220,
            column: 30
          },
          end: {
            line: 220,
            column: 65
          }
        }],
        line: 220
      },
      "29": {
        loc: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 221,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 221,
            column: 36
          }
        }, {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 221,
            column: 36
          }
        }],
        line: 221
      },
      "30": {
        loc: {
          start: {
            line: 221,
            column: 8
          },
          end: {
            line: 221,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 221,
            column: 8
          },
          end: {
            line: 221,
            column: 16
          }
        }, {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 28
          }
        }],
        line: 221
      },
      "31": {
        loc: {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 226,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 226,
            column: 5
          }
        }, {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 226,
            column: 5
          }
        }],
        line: 223
      },
      "32": {
        loc: {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }, {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }],
        line: 230
      },
      "33": {
        loc: {
          start: {
            line: 231,
            column: 17
          },
          end: {
            line: 231,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 231,
            column: 17
          },
          end: {
            line: 231,
            column: 52
          }
        }, {
          start: {
            line: 231,
            column: 56
          },
          end: {
            line: 231,
            column: 96
          }
        }],
        line: 231
      },
      "34": {
        loc: {
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 234,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 234,
            column: 57
          }
        }, {
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 234,
            column: 57
          }
        }],
        line: 234
      },
      "35": {
        loc: {
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 234,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 234,
            column: 36
          }
        }, {
          start: {
            line: 234,
            column: 40
          },
          end: {
            line: 234,
            column: 49
          }
        }],
        line: 234
      },
      "36": {
        loc: {
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 238,
            column: 96
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 238,
            column: 96
          }
        }, {
          start: {
            line: 238,
            column: 4
          },
          end: {
            line: 238,
            column: 96
          }
        }],
        line: 238
      },
      "37": {
        loc: {
          start: {
            line: 238,
            column: 31
          },
          end: {
            line: 238,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 238,
            column: 41
          },
          end: {
            line: 238,
            column: 67
          }
        }, {
          start: {
            line: 238,
            column: 70
          },
          end: {
            line: 238,
            column: 96
          }
        }],
        line: 238
      },
      "38": {
        loc: {
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 239,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 239,
            column: 80
          }
        }, {
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 239,
            column: 80
          }
        }],
        line: 239
      },
      "39": {
        loc: {
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 239,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 239,
            column: 15
          }
        }, {
          start: {
            line: 239,
            column: 19
          },
          end: {
            line: 239,
            column: 28
          }
        }],
        line: 239
      },
      "40": {
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 46
          }
        }, {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 46
          }
        }],
        line: 241
      },
      "41": {
        loc: {
          start: {
            line: 243,
            column: 11
          },
          end: {
            line: 243,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 243,
            column: 11
          },
          end: {
            line: 243,
            column: 46
          }
        }, {
          start: {
            line: 243,
            column: 11
          },
          end: {
            line: 243,
            column: 46
          }
        }],
        line: 243
      },
      "42": {
        loc: {
          start: {
            line: 250,
            column: 71
          },
          end: {
            line: 250,
            column: 104
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 250,
            column: 102
          },
          end: {
            line: 250,
            column: 104
          }
        }],
        line: 250
      },
      "43": {
        loc: {
          start: {
            line: 251,
            column: 12
          },
          end: {
            line: 251,
            column: 57
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 251,
            column: 26
          },
          end: {
            line: 251,
            column: 57
          }
        }],
        line: 251
      },
      "44": {
        loc: {
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 256,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 256,
            column: 5
          }
        }, {
          start: {
            line: 254,
            column: 4
          },
          end: {
            line: 256,
            column: 5
          }
        }],
        line: 254
      },
      "45": {
        loc: {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 37
          }
        }, {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 37
          }
        }],
        line: 278
      },
      "46": {
        loc: {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 279,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 279,
            column: 37
          }
        }, {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 279,
            column: 37
          }
        }],
        line: 279
      },
      "47": {
        loc: {
          start: {
            line: 291,
            column: 6
          },
          end: {
            line: 291,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 291,
            column: 20
          },
          end: {
            line: 291,
            column: 51
          }
        }],
        line: 291
      },
      "48": {
        loc: {
          start: {
            line: 292,
            column: 6
          },
          end: {
            line: 292,
            column: 53
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 292,
            column: 21
          },
          end: {
            line: 292,
            column: 53
          }
        }],
        line: 292
      },
      "49": {
        loc: {
          start: {
            line: 297,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 297,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        }, {
          start: {
            line: 297,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        }],
        line: 297
      },
      "50": {
        loc: {
          start: {
            line: 297,
            column: 8
          },
          end: {
            line: 297,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 297,
            column: 8
          },
          end: {
            line: 297,
            column: 25
          }
        }, {
          start: {
            line: 297,
            column: 29
          },
          end: {
            line: 297,
            column: 45
          }
        }],
        line: 297
      },
      "51": {
        loc: {
          start: {
            line: 298,
            column: 18
          },
          end: {
            line: 298,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 298,
            column: 38
          },
          end: {
            line: 298,
            column: 86
          }
        }, {
          start: {
            line: 298,
            column: 89
          },
          end: {
            line: 298,
            column: 93
          }
        }],
        line: 298
      },
      "52": {
        loc: {
          start: {
            line: 299,
            column: 17
          },
          end: {
            line: 299,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 299,
            column: 36
          },
          end: {
            line: 299,
            column: 84
          }
        }, {
          start: {
            line: 299,
            column: 87
          },
          end: {
            line: 299,
            column: 90
          }
        }],
        line: 299
      },
      "53": {
        loc: {
          start: {
            line: 312,
            column: 6
          },
          end: {
            line: 312,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 312,
            column: 20
          },
          end: {
            line: 312,
            column: 51
          }
        }],
        line: 312
      },
      "54": {
        loc: {
          start: {
            line: 313,
            column: 6
          },
          end: {
            line: 313,
            column: 53
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 313,
            column: 21
          },
          end: {
            line: 313,
            column: 53
          }
        }],
        line: 313
      },
      "55": {
        loc: {
          start: {
            line: 325,
            column: 23
          },
          end: {
            line: 325,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 325,
            column: 23
          },
          end: {
            line: 325,
            column: 30
          }
        }, {
          start: {
            line: 325,
            column: 34
          },
          end: {
            line: 325,
            column: 42
          }
        }],
        line: 325
      },
      "56": {
        loc: {
          start: {
            line: 325,
            column: 44
          },
          end: {
            line: 325,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 325,
            column: 44
          },
          end: {
            line: 325,
            column: 51
          }
        }, {
          start: {
            line: 325,
            column: 55
          },
          end: {
            line: 325,
            column: 63
          }
        }],
        line: 325
      },
      "57": {
        loc: {
          start: {
            line: 325,
            column: 65
          },
          end: {
            line: 325,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 325,
            column: 65
          },
          end: {
            line: 325,
            column: 68
          }
        }, {
          start: {
            line: 325,
            column: 72
          },
          end: {
            line: 325,
            column: 77
          }
        }],
        line: 325
      },
      "58": {
        loc: {
          start: {
            line: 329,
            column: 20
          },
          end: {
            line: 329,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 329,
            column: 44
          },
          end: {
            line: 329,
            column: 56
          }
        }, {
          start: {
            line: 329,
            column: 59
          },
          end: {
            line: 329,
            column: 65
          }
        }],
        line: 329
      },
      "59": {
        loc: {
          start: {
            line: 331,
            column: 18
          },
          end: {
            line: 331,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 18
          },
          end: {
            line: 331,
            column: 25
          }
        }, {
          start: {
            line: 331,
            column: 29
          },
          end: {
            line: 331,
            column: 73
          }
        }],
        line: 331
      },
      "60": {
        loc: {
          start: {
            line: 332,
            column: 18
          },
          end: {
            line: 332,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 18
          },
          end: {
            line: 332,
            column: 25
          }
        }, {
          start: {
            line: 332,
            column: 29
          },
          end: {
            line: 332,
            column: 70
          }
        }],
        line: 332
      },
      "61": {
        loc: {
          start: {
            line: 344,
            column: 11
          },
          end: {
            line: 353,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 344,
            column: 11
          },
          end: {
            line: 344,
            column: 18
          }
        }, {
          start: {
            line: 345,
            column: 12
          },
          end: {
            line: 352,
            column: 14
          }
        }],
        line: 344
      },
      "62": {
        loc: {
          start: {
            line: 348,
            column: 27
          },
          end: {
            line: 348,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 348,
            column: 51
          },
          end: {
            line: 348,
            column: 63
          }
        }, {
          start: {
            line: 348,
            column: 66
          },
          end: {
            line: 348,
            column: 75
          }
        }],
        line: 348
      },
      "63": {
        loc: {
          start: {
            line: 354,
            column: 11
          },
          end: {
            line: 356,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 354,
            column: 11
          },
          end: {
            line: 354,
            column: 18
          }
        }, {
          start: {
            line: 355,
            column: 12
          },
          end: {
            line: 355,
            column: 119
          }
        }],
        line: 354
      },
      "64": {
        loc: {
          start: {
            line: 358,
            column: 9
          },
          end: {
            line: 362,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 358,
            column: 9
          },
          end: {
            line: 358,
            column: 26
          }
        }, {
          start: {
            line: 359,
            column: 10
          },
          end: {
            line: 361,
            column: 16
          }
        }],
        line: 358
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0],
      "21": [0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0],
      "43": [0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0],
      "48": [0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0],
      "54": [0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Scroll/Scroll.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { banOverScrollX } from '../utils/dom/scrollBehavior';
import { PureComponent } from '../component';
import { getParent } from '../utils/dom/element';
import normalizeWheel from '../utils/dom/normalizeWheel';
import { scrollClass } from './styles';
import Bar from './Bar';
import config from '../config';
import { Provider } from './context';
import { throttleWrapper } from '../utils/lazyload';
import { isRTL } from '../config';
export var BAR_WIDTH = (cov_9djxi2lkq.s[0]++, 16);

var Scroll =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Scroll, _PureComponent);

  var _super = _createSuper2(Scroll);

  function Scroll(props) {
    var _this;

    _classCallCheck(this, Scroll);

    cov_9djxi2lkq.f[0]++;
    cov_9djxi2lkq.s[1]++;
    _this = _super.call(this, props);
    _this.baseScrollRatio = void 0;
    _this.touchStartX = void 0;
    _this.touchStartY = void 0;
    _this.wheelX = void 0;
    _this.wheelY = void 0;
    _this.pixelX = void 0;
    _this.pixelY = void 0;
    _this.cacheWidth = void 0;
    _this.cacheHeight = void 0;
    _this.wheelElement = void 0;
    _this.inner = void 0;
    _this.footerElement = void 0;
    _this.rmOverScrollListener = void 0;
    cov_9djxi2lkq.s[2]++;
    _this.touchStartX = 0;
    cov_9djxi2lkq.s[3]++;
    _this.touchStartY = 0;
    cov_9djxi2lkq.s[4]++;
    _this.wheelX = props.scrollX;
    cov_9djxi2lkq.s[5]++;
    _this.wheelY = props.scrollY;
    cov_9djxi2lkq.s[6]++;
    _this.pixelX = 0;
    cov_9djxi2lkq.s[7]++;
    _this.pixelY = 0;
    cov_9djxi2lkq.s[8]++;
    _this.cacheWidth = 0;
    cov_9djxi2lkq.s[9]++;
    _this.cacheHeight = 0;
    cov_9djxi2lkq.s[10]++;
    _this.bindInner = _this.bindInner.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[11]++;
    _this.bindWheel = _this.bindWheel.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[12]++;
    _this.bindFooter = _this.bindFooter.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[13]++;
    _this.setRect = _this.setRect.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[14]++;
    _this.handleScrollX = _this.handleScrollX.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[15]++;
    _this.handleScrollY = _this.handleScrollY.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[16]++;
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[17]++;
    _this.bindIframe = _this.bindIframe.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[18]++;
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[19]++;
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[20]++;
    _this.setStartPoint = _this.setStartPoint.bind(_assertThisInitialized(_this));
    cov_9djxi2lkq.s[21]++;
    _this.handleInnerScroll = _this.handleInnerScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Scroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_9djxi2lkq.f[1]++;
      cov_9djxi2lkq.s[22]++;

      _get(_getPrototypeOf(Scroll.prototype), "componentDidMount", this).call(this);

      cov_9djxi2lkq.s[23]++;
      setTimeout(this.setRect);
      cov_9djxi2lkq.s[24]++;
      this.wheelElement.addEventListener('wheel', this.handleWheel, {
        passive: false
      });
      cov_9djxi2lkq.s[25]++;
      this.wheelElement.addEventListener('touchstart', this.handleTouchStart, {
        passive: true
      });
      cov_9djxi2lkq.s[26]++;
      this.wheelElement.addEventListener('touchmove', this.handleTouchMove, {
        passive: false
      });
      cov_9djxi2lkq.s[27]++;
      this.inner.addEventListener('scroll', this.handleInnerScroll);
      cov_9djxi2lkq.s[28]++;
      this.wheelElement.addEventListener('scroll', this.handleInnerScroll);
      cov_9djxi2lkq.s[29]++;
      this.rmOverScrollListener = banOverScrollX(this.wheelElement);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_9djxi2lkq.f[2]++;

      var _ref = (cov_9djxi2lkq.s[30]++, this.props),
          stable = _ref.stable,
          scrollWidth = _ref.scrollWidth,
          scrollHeight = _ref.scrollHeight;

      cov_9djxi2lkq.s[31]++;

      if (scrollWidth !== prevProps.scrollWidth) {
        cov_9djxi2lkq.b[0][0]++;
        cov_9djxi2lkq.s[32]++;
        this.setRect();
      } else {
        cov_9djxi2lkq.b[0][1]++;
        cov_9djxi2lkq.s[33]++;

        if ((cov_9djxi2lkq.b[2][0]++, stable) && (cov_9djxi2lkq.b[2][1]++, scrollHeight !== prevProps.scrollHeight)) {
          cov_9djxi2lkq.b[1][0]++;
          cov_9djxi2lkq.s[34]++;
          this.setRect();
        } else {
          cov_9djxi2lkq.b[1][1]++;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_9djxi2lkq.f[3]++;
      cov_9djxi2lkq.s[35]++;

      _get(_getPrototypeOf(Scroll.prototype), "componentWillUnmount", this).call(this);

      cov_9djxi2lkq.s[36]++;
      this.wheelElement.removeEventListener('wheel', this.handleWheel);
      cov_9djxi2lkq.s[37]++;
      this.wheelElement.removeEventListener('touchstart', this.handleTouchStart);
      cov_9djxi2lkq.s[38]++;
      this.wheelElement.removeEventListener('touchmove', this.handleTouchMove);
      cov_9djxi2lkq.s[39]++;
      this.inner.removeEventListener('scroll', this.handleInnerScroll);
      cov_9djxi2lkq.s[40]++;
      this.wheelElement.removeEventListener('scroll', this.handleInnerScroll);
      cov_9djxi2lkq.s[41]++;

      if (this.footerElement) {
        cov_9djxi2lkq.b[3][0]++;
        cov_9djxi2lkq.s[42]++;
        this.footerElement.removeEventListener('wheel', this.handleWheel);
        cov_9djxi2lkq.s[43]++;
        this.footerElement.removeEventListener('touchstart', this.handleTouchStart);
        cov_9djxi2lkq.s[44]++;
        this.footerElement.removeEventListener('touchmove', this.handleTouchMove);
      } else {
        cov_9djxi2lkq.b[3][1]++;
      }

      cov_9djxi2lkq.s[45]++;

      if (this.rmOverScrollListener) {
        cov_9djxi2lkq.b[4][0]++;
        cov_9djxi2lkq.s[46]++;
        this.rmOverScrollListener();
      } else {
        cov_9djxi2lkq.b[4][1]++;
      }
    }
  }, {
    key: "getWheelRect",
    value: function getWheelRect() {
      cov_9djxi2lkq.f[4]++;
      cov_9djxi2lkq.s[47]++;

      if (!this.wheelElement) {
        cov_9djxi2lkq.b[5][0]++;
        cov_9djxi2lkq.s[48]++;
        return {
          width: 0,
          height: 0
        };
      } else {
        cov_9djxi2lkq.b[5][1]++;
      }

      var _ref2 = (cov_9djxi2lkq.s[49]++, this.wheelElement.getBoundingClientRect()),
          width = _ref2.width,
          height = _ref2.height; // display none


      cov_9djxi2lkq.s[50]++;

      if ((cov_9djxi2lkq.b[7][0]++, width === 0) && (cov_9djxi2lkq.b[7][1]++, height === 0)) {
        cov_9djxi2lkq.b[6][0]++;
        cov_9djxi2lkq.s[51]++;
        width = this.cacheWidth;
        cov_9djxi2lkq.s[52]++;
        height = this.cacheHeight;
      } else {
        cov_9djxi2lkq.b[6][1]++;
        cov_9djxi2lkq.s[53]++;
        this.cacheWidth = width;
        cov_9djxi2lkq.s[54]++;
        this.cacheHeight = height;
      }

      var _ref3 = (cov_9djxi2lkq.s[55]++, this.props),
          scrollX = _ref3.scrollX,
          scrollY = _ref3.scrollY,
          _ref3$style = _ref3.style,
          style = _ref3$style === void 0 ? (cov_9djxi2lkq.b[8][0]++, {}) : _ref3$style;

      cov_9djxi2lkq.s[56]++;
      width = (typeof style.width === 'number' ? (cov_9djxi2lkq.b[9][0]++, style.width) : (cov_9djxi2lkq.b[9][1]++, width)) - (scrollY ? (cov_9djxi2lkq.b[10][0]++, BAR_WIDTH) : (cov_9djxi2lkq.b[10][1]++, 0));
      cov_9djxi2lkq.s[57]++;
      height = (typeof style.height === 'number' ? (cov_9djxi2lkq.b[11][0]++, style.height) : (cov_9djxi2lkq.b[11][1]++, height)) - (scrollX ? (cov_9djxi2lkq.b[12][0]++, BAR_WIDTH) : (cov_9djxi2lkq.b[12][1]++, 0));
      cov_9djxi2lkq.s[58]++;
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "setRect",
    value: function setRect() {
      cov_9djxi2lkq.f[5]++;
      cov_9djxi2lkq.s[59]++;
      this.handleScroll(this.props.left, this.props.top);
      cov_9djxi2lkq.s[60]++;
      this.forceUpdate();
    }
  }, {
    key: "setBaseScrollHeightRatio",
    value: function setBaseScrollHeightRatio(height) {
      cov_9djxi2lkq.f[6]++;
      cov_9djxi2lkq.s[61]++;

      if (this.baseScrollRatio) {
        cov_9djxi2lkq.b[13][0]++;
        cov_9djxi2lkq.s[62]++;
        return;
      } else {
        cov_9djxi2lkq.b[13][1]++;
      }

      cov_9djxi2lkq.s[63]++;
      this.baseScrollRatio = 1;
      var ratio = (cov_9djxi2lkq.s[64]++, config.scrollRatio); // windows scroll

      cov_9djxi2lkq.s[65]++;

      if (Math.abs(height) > 10) {
        cov_9djxi2lkq.b[14][0]++;
        cov_9djxi2lkq.s[66]++;
        this.baseScrollRatio = ratio / Math.abs(height);
      } else {
        cov_9djxi2lkq.b[14][1]++;
      }
    }
  }, {
    key: "setStartPoint",
    value: function setStartPoint(position) {
      cov_9djxi2lkq.f[7]++;
      cov_9djxi2lkq.s[67]++;
      this.touchStartX = position.clientX;
      cov_9djxi2lkq.s[68]++;
      this.touchStartY = position.clientY;
    }
  }, {
    key: "bindInner",
    value: function bindInner(el) {
      cov_9djxi2lkq.f[8]++;
      cov_9djxi2lkq.s[69]++;
      this.inner = el;
    }
  }, {
    key: "bindIframe",
    value: function bindIframe(el) {
      cov_9djxi2lkq.f[9]++;
      cov_9djxi2lkq.s[70]++;

      if ((cov_9djxi2lkq.b[16][0]++, el) && (cov_9djxi2lkq.b[16][1]++, el.contentWindow)) {
        cov_9djxi2lkq.b[15][0]++;
        cov_9djxi2lkq.s[71]++;
        el.contentWindow.onresize = throttleWrapper(this.setRect);
      } else {
        cov_9djxi2lkq.b[15][1]++;
      }
    }
  }, {
    key: "bindWheel",
    value: function bindWheel(el) {
      cov_9djxi2lkq.f[10]++;
      cov_9djxi2lkq.s[72]++;
      this.wheelElement = el;
    }
  }, {
    key: "bindFooter",
    value: function bindFooter(el) {
      cov_9djxi2lkq.f[11]++;
      cov_9djxi2lkq.s[73]++;

      if (this.footerElement) {
        cov_9djxi2lkq.b[17][0]++;
        cov_9djxi2lkq.s[74]++;
        this.footerElement.removeEventListener('wheel', this.handleWheel);
        cov_9djxi2lkq.s[75]++;
        this.footerElement.removeEventListener('touchstart', this.handleTouchStart);
        cov_9djxi2lkq.s[76]++;
        this.footerElement.removeEventListener('touchmove', this.handleTouchMove);
      } else {
        cov_9djxi2lkq.b[17][1]++;
      }

      cov_9djxi2lkq.s[77]++;

      if (el) {
        cov_9djxi2lkq.b[18][0]++;
        cov_9djxi2lkq.s[78]++;
        el.addEventListener('wheel', this.handleWheel, {
          passive: false
        });
        cov_9djxi2lkq.s[79]++;
        el.addEventListener('touchstart', this.handleTouchStart, {
          passive: true
        });
        cov_9djxi2lkq.s[80]++;
        el.addEventListener('touchmove', this.handleTouchMove, {
          passive: false
        });
      } else {
        cov_9djxi2lkq.b[18][1]++;
      }

      cov_9djxi2lkq.s[81]++;
      this.footerElement = el;
    }
  }, {
    key: "boundleScroll",
    value: function boundleScroll() {
      cov_9djxi2lkq.f[12]++;
      cov_9djxi2lkq.s[82]++;

      /*
      this.locked = true
      this.scrollTimer = setTimeout(() => {
        this.locked = false
        if (this.pixelX !== 0 || this.pixelY !== 0) {
          this.boundleScroll()
        }
      }, 32)
      */
      // lock direction
      if (Math.abs(this.pixelX) > Math.abs(this.pixelY)) {
        cov_9djxi2lkq.b[19][0]++;
        cov_9djxi2lkq.s[83]++;
        this.pixelY = 0;
      } else {
        cov_9djxi2lkq.b[19][1]++;
        cov_9djxi2lkq.s[84]++;
        this.pixelX = 0;
      }

      var _ref4 = (cov_9djxi2lkq.s[85]++, this.props),
          left = _ref4.left,
          top = _ref4.top;

      var _ref5 = (cov_9djxi2lkq.s[86]++, this.props),
          _ref5$scrollWidth = _ref5.scrollWidth,
          scrollWidth = _ref5$scrollWidth === void 0 ? (cov_9djxi2lkq.b[20][0]++, Scroll.defaultProps.scrollWidth) : _ref5$scrollWidth,
          _ref5$scrollHeight = _ref5.scrollHeight,
          scrollHeight = _ref5$scrollHeight === void 0 ? (cov_9djxi2lkq.b[21][0]++, Scroll.defaultProps.scrollHeight) : _ref5$scrollHeight;

      var x = (cov_9djxi2lkq.s[87]++, left + this.pixelX / scrollWidth);
      cov_9djxi2lkq.s[88]++;

      if (x < 0) {
        cov_9djxi2lkq.b[22][0]++;
        cov_9djxi2lkq.s[89]++;
        x = 0;
      } else {
        cov_9djxi2lkq.b[22][1]++;
      }

      cov_9djxi2lkq.s[90]++;

      if (x > 1) {
        cov_9djxi2lkq.b[23][0]++;
        cov_9djxi2lkq.s[91]++;
        x = 1;
      } else {
        cov_9djxi2lkq.b[23][1]++;
      }

      var y = (cov_9djxi2lkq.s[92]++, top + this.pixelY / scrollHeight);
      cov_9djxi2lkq.s[93]++;

      if (y < 0) {
        cov_9djxi2lkq.b[24][0]++;
        cov_9djxi2lkq.s[94]++;
        y = 0;
      } else {
        cov_9djxi2lkq.b[24][1]++;
      }

      cov_9djxi2lkq.s[95]++;

      if (y > 1) {
        cov_9djxi2lkq.b[25][0]++;
        cov_9djxi2lkq.s[96]++;
        y = 1;
      } else {
        cov_9djxi2lkq.b[25][1]++;
      }

      cov_9djxi2lkq.s[97]++;

      if ((cov_9djxi2lkq.b[27][0]++, x !== left) || (cov_9djxi2lkq.b[27][1]++, y !== top)) {
        cov_9djxi2lkq.b[26][0]++;
        cov_9djxi2lkq.s[98]++;
        this.handleScroll(x, y, this.pixelX, this.pixelY);
      } else {
        cov_9djxi2lkq.b[26][1]++;
      }

      cov_9djxi2lkq.s[99]++;
      this.pixelX = 0;
      cov_9djxi2lkq.s[100]++;
      this.pixelY = 0;
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(event) {
      cov_9djxi2lkq.f[13]++;
      var scrollX = (cov_9djxi2lkq.s[101]++, this.wheelX);
      var scrollY = (cov_9djxi2lkq.s[102]++, this.wheelY);

      var _ref6 = (cov_9djxi2lkq.s[103]++, this.props),
          _ref6$innerScrollAttr = _ref6.innerScrollAttr,
          innerScrollAttr = _ref6$innerScrollAttr === void 0 ? (cov_9djxi2lkq.b[28][0]++, Scroll.defaultProps.innerScrollAttr) : _ref6$innerScrollAttr;

      cov_9djxi2lkq.s[104]++;

      if ((cov_9djxi2lkq.b[30][0]++, !scrollX) && (cov_9djxi2lkq.b[30][1]++, !scrollY)) {
        cov_9djxi2lkq.b[29][0]++;
        cov_9djxi2lkq.s[105]++;
        return;
      } else {
        cov_9djxi2lkq.b[29][1]++;
      }

      var wheelTarget = (cov_9djxi2lkq.s[106]++, event.target);
      cov_9djxi2lkq.s[107]++;

      if (innerScrollAttr.find(function (attr) {
        cov_9djxi2lkq.f[14]++;
        cov_9djxi2lkq.s[108]++;
        return wheelTarget.hasAttribute(attr);
      })) {
        cov_9djxi2lkq.b[31][0]++;
        cov_9djxi2lkq.s[109]++;
        event.stopPropagation();
        cov_9djxi2lkq.s[110]++;
        return;
      } else {
        cov_9djxi2lkq.b[31][1]++;
      }

      var target = (cov_9djxi2lkq.s[111]++, getParent(wheelTarget, ".".concat(scrollClass('_'))));
      var inFooter = (cov_9djxi2lkq.s[112]++, false);
      cov_9djxi2lkq.s[113]++;

      if (this.footerElement) {
        cov_9djxi2lkq.b[32][0]++;
        cov_9djxi2lkq.s[114]++;
        inFooter = (cov_9djxi2lkq.b[33][0]++, this.footerElement === event.target) || (cov_9djxi2lkq.b[33][1]++, this.footerElement.contains(wheelTarget));
      } else {
        cov_9djxi2lkq.b[32][1]++;
      }

      cov_9djxi2lkq.s[115]++;

      if ((cov_9djxi2lkq.b[35][0]++, target !== this.wheelElement) && (cov_9djxi2lkq.b[35][1]++, !inFooter)) {
        cov_9djxi2lkq.b[34][0]++;
        cov_9djxi2lkq.s[116]++;
        return;
      } else {
        cov_9djxi2lkq.b[34][1]++;
      }

      var wheel = (cov_9djxi2lkq.s[117]++, normalizeWheel(event));
      cov_9djxi2lkq.s[118]++;
      this.setBaseScrollHeightRatio(wheel.pixelY);
      cov_9djxi2lkq.s[119]++;

      if (scrollX) {
        cov_9djxi2lkq.b[36][0]++;
        cov_9djxi2lkq.s[120]++;
        this.pixelX = isRTL() ? (cov_9djxi2lkq.b[37][0]++, this.pixelX - wheel.pixelX) : (cov_9djxi2lkq.b[37][1]++, this.pixelX + wheel.pixelX);
      } else {
        cov_9djxi2lkq.b[36][1]++;
      }

      cov_9djxi2lkq.s[121]++;

      if ((cov_9djxi2lkq.b[39][0]++, scrollY) && (cov_9djxi2lkq.b[39][1]++, !inFooter)) {
        cov_9djxi2lkq.b[38][0]++;
        cov_9djxi2lkq.s[122]++;
        this.pixelY += wheel.pixelY * this.baseScrollRatio;
      } else {
        cov_9djxi2lkq.b[38][1]++;
      }

      cov_9djxi2lkq.s[123]++;

      if (Math.abs(wheel.pixelX) > Math.abs(wheel.pixelY)) {
        cov_9djxi2lkq.b[40][0]++;
        cov_9djxi2lkq.s[124]++;
        event.preventDefault();
      } else {
        cov_9djxi2lkq.b[40][1]++;
        cov_9djxi2lkq.s[125]++;

        if (scrollY) {
          cov_9djxi2lkq.b[41][0]++;
          cov_9djxi2lkq.s[126]++;
          event.preventDefault();
        } else {
          cov_9djxi2lkq.b[41][1]++;
        }
      } // if (!this.locked) {


      cov_9djxi2lkq.s[127]++;
      this.boundleScroll(); // }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(x, y, pixelX, pixelY) {
      var _ref7 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (cov_9djxi2lkq.b[42][0]++, {}),
          drag = _ref7.drag;

      cov_9djxi2lkq.f[15]++;

      var _ref8 = (cov_9djxi2lkq.s[128]++, this.props),
          _ref8$scrollWidth = _ref8.scrollWidth,
          scrollWidth = _ref8$scrollWidth === void 0 ? (cov_9djxi2lkq.b[43][0]++, Scroll.defaultProps.scrollWidth) : _ref8$scrollWidth;

      var _ref9 = (cov_9djxi2lkq.s[129]++, this.getWheelRect()),
          width = _ref9.width,
          height = _ref9.height;

      var max = (cov_9djxi2lkq.s[130]++, Math.round((1 - width / scrollWidth) * scrollWidth));
      cov_9djxi2lkq.s[131]++;

      if (this.props.onScroll) {
        cov_9djxi2lkq.b[44][0]++;
        cov_9djxi2lkq.s[132]++;
        this.props.onScroll(x, y, max, this.inner, width, height, pixelX, pixelY, drag);
      } else {
        cov_9djxi2lkq.b[44][1]++;
      }
    }
  }, {
    key: "handleScrollX",
    value: function handleScrollX(left) {
      cov_9djxi2lkq.f[16]++;
      cov_9djxi2lkq.s[133]++;
      this.handleScroll(left, this.props.top, undefined, 0, {
        drag: true
      });
    }
  }, {
    key: "handleScrollY",
    value: function handleScrollY(top) {
      cov_9djxi2lkq.f[17]++;
      cov_9djxi2lkq.s[134]++;
      this.handleScroll(this.props.left, top, undefined, undefined, {
        drag: true
      });
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(e) {
      cov_9djxi2lkq.f[18]++;
      cov_9djxi2lkq.s[135]++;
      this.setStartPoint(e.changedTouches[0]);
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(e) {
      cov_9djxi2lkq.f[19]++;

      var _ref10 = (cov_9djxi2lkq.s[136]++, this.props),
          scrollX = _ref10.scrollX,
          scrollY = _ref10.scrollY;

      cov_9djxi2lkq.s[137]++;
      e.preventDefault();
      var position = (cov_9djxi2lkq.s[138]++, e.changedTouches[0]);
      var moveX = (cov_9djxi2lkq.s[139]++, position.clientX - this.touchStartX);
      var moveY = (cov_9djxi2lkq.s[140]++, position.clientY - this.touchStartY);
      cov_9djxi2lkq.s[141]++;

      if (scrollX) {
        cov_9djxi2lkq.b[45][0]++;
        cov_9djxi2lkq.s[142]++;
        this.pixelX = -moveX;
      } else {
        cov_9djxi2lkq.b[45][1]++;
      }

      cov_9djxi2lkq.s[143]++;

      if (scrollY) {
        cov_9djxi2lkq.b[46][0]++;
        cov_9djxi2lkq.s[144]++;
        this.pixelY = -moveY;
      } else {
        cov_9djxi2lkq.b[46][1]++;
      } // need reset the start


      cov_9djxi2lkq.s[145]++;
      this.setStartPoint(position);
      cov_9djxi2lkq.s[146]++;
      this.boundleScroll();
    } // handle inner scroll cased by input focus

  }, {
    key: "handleInnerScroll",
    value: function handleInnerScroll(e) {
      cov_9djxi2lkq.f[20]++;

      var _ref11 = (cov_9djxi2lkq.s[147]++, e),
          target = _ref11.target;

      var _ref12 = (cov_9djxi2lkq.s[148]++, this.props),
          _ref12$scrollWidth = _ref12.scrollWidth,
          scrollWidth = _ref12$scrollWidth === void 0 ? (cov_9djxi2lkq.b[47][0]++, Scroll.defaultProps.scrollWidth) : _ref12$scrollWidth,
          _ref12$scrollHeight = _ref12.scrollHeight,
          scrollHeight = _ref12$scrollHeight === void 0 ? (cov_9djxi2lkq.b[48][0]++, Scroll.defaultProps.scrollHeight) : _ref12$scrollHeight,
          left = _ref12.left,
          top = _ref12.top;

      var _ref13 = (cov_9djxi2lkq.s[149]++, this.getWheelRect()),
          width = _ref13.width,
          height = _ref13.height;

      cov_9djxi2lkq.s[150]++;

      if ((cov_9djxi2lkq.b[50][0]++, target.scrollLeft) || (cov_9djxi2lkq.b[50][1]++, target.scrollTop)) {
        cov_9djxi2lkq.b[49][0]++;
        var sLeft = (cov_9djxi2lkq.s[151]++, target.scrollLeft ? (cov_9djxi2lkq.b[51][0]++, left + target.scrollLeft / (scrollWidth - width)) : (cov_9djxi2lkq.b[51][1]++, left));
        var sTop = (cov_9djxi2lkq.s[152]++, target.scrollTop ? (cov_9djxi2lkq.b[52][0]++, top + target.scrollTop / (scrollHeight - height)) : (cov_9djxi2lkq.b[52][1]++, top));
        cov_9djxi2lkq.s[153]++;
        sTop = Math.min(1, sTop);
        cov_9djxi2lkq.s[154]++;
        sTop = Math.max(0, sTop);
        cov_9djxi2lkq.s[155]++;
        sLeft = Math.min(1, sLeft);
        cov_9djxi2lkq.s[156]++;
        sLeft = Math.max(0, sLeft);
        cov_9djxi2lkq.s[157]++;
        this.handleScroll(sLeft, sTop, undefined, undefined, {
          drag: true
        });
        cov_9djxi2lkq.s[158]++;
        target.scrollLeft = 0;
        cov_9djxi2lkq.s[159]++;
        target.scrollTop = 0;
      } else {
        cov_9djxi2lkq.b[49][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_9djxi2lkq.f[21]++;

      var _ref14 = (cov_9djxi2lkq.s[160]++, this.props),
          _ref14$scrollWidth = _ref14.scrollWidth,
          scrollWidth = _ref14$scrollWidth === void 0 ? (cov_9djxi2lkq.b[53][0]++, Scroll.defaultProps.scrollWidth) : _ref14$scrollWidth,
          _ref14$scrollHeight = _ref14.scrollHeight,
          scrollHeight = _ref14$scrollHeight === void 0 ? (cov_9djxi2lkq.b[54][0]++, Scroll.defaultProps.scrollHeight) : _ref14$scrollHeight,
          children = _ref14.children,
          left = _ref14.left,
          top = _ref14.top,
          scrollX = _ref14.scrollX,
          scrollY = _ref14.scrollY,
          style = _ref14.style;

      var _ref15 = (cov_9djxi2lkq.s[161]++, this.getWheelRect()),
          width = _ref15.width,
          height = _ref15.height;

      var rtl = (cov_9djxi2lkq.s[162]++, isRTL());
      var className = (cov_9djxi2lkq.s[163]++, classnames(scrollClass('_', (cov_9djxi2lkq.b[55][0]++, scrollX) && (cov_9djxi2lkq.b[55][1]++, 'show-x'), (cov_9djxi2lkq.b[56][0]++, scrollY) && (cov_9djxi2lkq.b[56][1]++, 'show-y'), (cov_9djxi2lkq.b[57][0]++, rtl) && (cov_9djxi2lkq.b[57][1]++, 'rtl')), this.props.className));
      var yLength = (cov_9djxi2lkq.s[164]++, scrollHeight < height ? (cov_9djxi2lkq.b[58][0]++, scrollHeight) : (cov_9djxi2lkq.b[58][1]++, height));
      cov_9djxi2lkq.s[165]++;
      this.wheelY = (cov_9djxi2lkq.b[59][0]++, scrollY) && (cov_9djxi2lkq.b[59][1]++, Math.ceil(scrollHeight) > Math.ceil(yLength));
      cov_9djxi2lkq.s[166]++;
      this.wheelX = (cov_9djxi2lkq.b[60][0]++, scrollX) && (cov_9djxi2lkq.b[60][1]++, Math.ceil(scrollWidth) > Math.ceil(width));
      cov_9djxi2lkq.s[167]++;
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          ref: this.bindWheel,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 336,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("iframe", {
          tabIndex: -1,
          title: "scroll",
          ref: this.bindIframe,
          className: scrollClass('iframe'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 337,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: scrollClass('iframe'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 338,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindInner,
          className: scrollClass('inner'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 339,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: {
            left: left * width,
            top: top * height,
            element: this.wheelElement
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 340,
            columnNumber: 13
          }
        }, children)), (cov_9djxi2lkq.b[61][0]++, scrollY) && (cov_9djxi2lkq.b[61][1]++,
        /*#__PURE__*/
        React.createElement(Bar, {
          direction: "y",
          length: yLength,
          forceHeight: scrollHeight < height ? (cov_9djxi2lkq.b[62][0]++, scrollHeight) : (cov_9djxi2lkq.b[62][1]++, undefined),
          scrollLength: scrollHeight,
          offset: top,
          onScroll: this.handleScrollY,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 345,
            columnNumber: 13
          }
        })), (cov_9djxi2lkq.b[63][0]++, scrollX) && (cov_9djxi2lkq.b[63][1]++,
        /*#__PURE__*/
        React.createElement(Bar, {
          direction: "x",
          length: width,
          scrollLength: scrollWidth,
          offset: left,
          onScroll: this.handleScrollX,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 355,
            columnNumber: 13
          }
        }))), (cov_9djxi2lkq.b[64][0]++, this.props.footer) && (cov_9djxi2lkq.b[64][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindFooter,
          className: scrollClass('footer'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 359,
            columnNumber: 11
          }
        }, this.props.footer)))
      );
    }
  }]);

  return Scroll;
}(PureComponent);

Scroll.defaultProps = {
  scrollHeight: 0,
  scrollWidth: 0,
  innerScrollAttr: []
};
export default Scroll;